import React from "react";
import Layout from "../components/Layout";
import "./Tools.css";
import { navBar, navSlide, navDesign } from "../data/data";
import { useState } from "react";
export default function Tools() {
  const [index, setIndex] = useState([0, 1]);
  const [data, getData] = useState([navSlide[0], navSlide[1]]);
  const handleRight = () => {
    let [indexFirst, indexSecond] = index;
    if (indexFirst > 2) {
      indexFirst = 0;
      indexSecond += 1;
    } else if (indexSecond > 2) {
      indexFirst += 1;
      indexSecond = 0;
    } else {
      indexFirst += 1;
      indexSecond += 1;
    }
    setIndex([indexFirst, indexSecond]);
    getData([navSlide[index[0]], navSlide[index[1]]]);
  };

  const handleLeft = () => {
    let [indexFirst, indexSecond] = index;
    if (indexFirst < 1) {
      indexFirst = 3;
      indexSecond -= 1;
    } else if (indexSecond < 1) {
      indexFirst -= 1;
      indexSecond = 3;
    } else {
      indexFirst -= 1;
      indexSecond -= 1;
    }
    setIndex([indexFirst, indexSecond]);
    getData([navSlide[index[0]], navSlide[index[1]]]);
  };
  return (
    <Layout>
      <div className="container-tool">
        <ul>
          {navBar.map((item) => {
            return (
              <li key={item.id}>
                {item.svg && (
                  <div>
                    {" "}
                    <img src={item.svg} alt="#" />
                  </div>
                )}
                <p>{item.title}</p>
              </li>
            );
          })}
          <li>
            <div>
              <i class="fa fa-search"></i>
              <input type="text" placeholder="Search" />
            </div>
          </li>
        </ul>
      </div>
      <div
        style={{
          width: "60%",
          margin: "auto",
          paddingTop: "20px",
          color: "rgb(69, 69, 69)",
        }}
      >
        <h3 style={{ fontSize: "30px" }}>Tools & API</h3>
        <p style={{ textAlign: "left", fontSize: "18px" }}>
          Save time, boost productivity and supercharge your workflow by
          integrating the world's best automatic background removal solution
          into your everyday work. Here is a curated selection of the top
          integrations for remove.bg.
        </p>
      </div>
      <div className="container-navSlide">
        {data.map((item) => {
          return (
            <div key={item.id}>
              {/* <div style={{backgroundImage:`url(${item.src})`}}></div> */}
              <div>
                <img src={item.src} alt="#" />
              </div>
              <div>
                <p style={{ marginRight: "auto", color: "#bac0c4" }}>Feature</p>
                <h3
                  style={{
                    marginRight: "auto",
                    textAlign: "left",
                    color: "#454545",
                  }}
                >
                  {item.title}
                </h3>
                <p style={{ marginRight: "auto", textAlign: "left" }}>
                  {item.content}
                </p>
                <p
                  style={{
                    marginRight: "auto",
                    textAlign: "left",
                    color: "#2699fb",
                    cursor: "pointer",
                  }}
                >
                  Learn more
                </p>
              </div>
              {/* <div className="top-icon" ><h4>OFFICAL</h4></div> */}
            </div>
          );
        })}
        <i
          className="fa fa-arrow-right"
          aria-hidden="true"
          onClick={handleRight}
        ></i>
        <i
          className="fa fa-arrow-left"
          aria-hidden="true"
          onClick={handleLeft}
        ></i>
      </div>
      <div
        style={{
          width: "60%",
          margin: "auto",
          paddingTop: "10px",
          color: "rgb(69, 69, 69)",
          fontSize: "26px",
        }}
      >
        <h3>Design & Photo Editing</h3>
      </div>
      <div className="container-design">
        {navDesign.map((item) => {
          return (
            <div
              key={item.key}
              style={{
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px", margin : "10px"
              }}
            >
              <div style={{ maxWidth: "100px", maxHeight: "100px" }}>
                <img src={item.src} alt="#" />
              </div>
              <h3 style={{textAlign: "center",width: "80%",margin:"auto",fontSize:"20px",color: "rgb(69, 69, 69)"}}>{item.title}</h3>
              <p style={{marginBottom :"auto",color: "#bac0c4" }}>{item.author}</p>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}
